export default __webpack_public_path__ + "static/slider-general-8fd387e267f20b221feca3f9540535f9.jpg";